var themeContract = {
  argos: {
    price: {
      color: 'brand-2'
    }
  },
  habitat: {
    price: {
      color: 'brand-1-dark'
    }
  },
  tu: {
    price: {
      color: 'brand-1-dark'
    }
  },
  nectar: {
    price: {
      color: 'brand-1'
    }
  },
  sainsburys: {
    price: {
      color: 'brand-1'
    }
  }
};
export { themeContract };